module.exports = __webpack_public_path__ + "static/media/food.752c54e4.jpg";